@if (cctvInspections.length > 1 && selectedCctvInspection === null) {
  <div [style.height.px]="inspHeight">
    <h3 class="title">Inspections</h3>
    <div class="addresses">
      @for (insp of cctvInspections; track insp) {
        <div class="address d-flex justify-content-between">
          <div class="video text-start">
            @if (insp.video) {
              <div>
                @if (insp.video.length > 0) {
                  <span>
                    <a target="_blank" href="{{insp.video}}"><i class="fas fa-video"></i></a>
                  </span>
                }
              </div>
            }
          </div>
          <button class="w-100 btn btn-link d-flex justify-content-between" (click)="selectInspection(insp)"
            (mouseenter)="onCCTVHover(insp.assetId)" (mouseleave)="mouseLeave()">
            <div class="row mx-0 px-2">
              <div class="text-start">
                @if (getInspectJobVals(insp.attrs); as inspObj) {
                  {{inspObj.jobDate | date: 'yyyy-MM-dd'}}<br />
                  {{inspObj.assetId}}
                }
              </div>
            </div>
            <div class="cctv-chevron">
              <i class="far fa-chevron-right"></i>
            </div>
          </button>
        </div>
      }
    </div>
  </div>
}
@if (selectedCctvInspection !== null) {
  <div class="inspection-details px-2" [style.height.px]="inspHeight">
    @if (cctvInspections.length > 1) {
      <button class="btn btn-link btnBackToInsp px-0" (click)="backToInspections()">
        <i class="fas fa-chevron-left"></i>
        Selected Inspection
      </button>
    }
    @if (selectedCctvInspection; as inspect) {
      @if (inspect.video) {
        <div class="key-pair">
          <span class="label">Video</span>
          @if (inspect.video.length > 0) {
            <span>
              <a target="_blank" href="{{inspect.video}}"><i class="fas fa-video"></i></a>
            </span>
          }
        </div>
      }
      @if (!inspect.video) {
        <div class="key-pair">
          <span class="label">Video</span>
          <span>
            No video available
          </span>
        </div>
      }
      @if (inspect.attachment && inspect.attachment.length > 0) {
        <div>
          <ngx-gallery [options]="inspect.galleryOptions" [images]="inspect.attachment"
            [class.singleImage]="inspect.attachment.length == 1" class="feature-gallery">
          </ngx-gallery>
        </div>
      }
    }
    @if (selectedCctvInspection) {
      <div>
        <dnv-key-value-list title="Asset Details" [kvpairs]="selectedCctvInspection?.attrs"
          [excludesList]="excludeFeaturesList"
        [roundNumberList]="[{field: 'PIPELENGTH', digits: 2},{field: 'TOTALLENGTH', digits: 2}]"></dnv-key-value-list>
      </div>
    }
    <div>
      <h3>Observation Details</h3>
    </div>
    @if (cctvNotes.cctvData.length > 0) {
      <div>
        @for (notes of cctvNotes.cctvData; track trackByFn($index, notes)) {
          <div>
            <h4>{{notes.title}}</h4>
            @if (notes.img.length) {
              <ngx-gallery [options]="cctvNotes.galleryOptions" [images]="notes.img"
              class="feature-gallery" [class.noThumbs]="notes.img.length < 2"></ngx-gallery>
            }
            <dnv-key-value-list title="Observation Details" [kvpairs]="notes.kvPair" [excludesList]="excludeFeaturesList">
            </dnv-key-value-list>
          </div>
        }
      </div>
    } @else {
      <div class="no-notes">No notes found</div>
    }
  </div>
}